export default __webpack_public_path__ + "static/media/Hitachi.2bb7e63b.png";